import React from 'react';
import clsx from 'clsx';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  glass?: boolean;
  hover?: boolean;
  onClick?: () => void;
  id?: string;
  style?: React.CSSProperties;
}

export function Card({ children, className, glass = false, hover = false, onClick, id, style }: CardProps) {
  return (
    <div
      id={id}
      style={style}
      className={clsx('card', glass && 'card--glass', hover && 'card--hover', className)}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      {children}
    </div>
  );
}

interface KpiCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  icon: React.ReactNode;
  color?: 'default' | 'danger' | 'warning' | 'success' | 'info';
  trend?: { value: number; label: string };
}

export function KpiCard({ title, value, subtitle, icon, color = 'default', trend }: KpiCardProps) {
  return (
    <div className={clsx('kpi-card', `kpi-card--${color}`)}>
      <div className="kpi-card__header">
        <div className="kpi-card__icon-wrap">{icon}</div>
        <div className="kpi-card__content">
          <p className="kpi-card__title">{title}</p>
          <p className="kpi-card__value">{value}</p>
          {subtitle && <p className="kpi-card__subtitle">{subtitle}</p>}
        </div>
      </div>
      {trend && (
        <div className={clsx('kpi-card__trend', trend.value >= 0 ? 'kpi-card__trend--up' : 'kpi-card__trend--down')}>
          <span>{trend.value >= 0 ? '▲' : '▼'} {Math.abs(trend.value)}%</span>
          <span>{trend.label}</span>
        </div>
      )}
    </div>
  );
}
